import React from "react";
import styles from "./css/GreenLightningIcon.module.css";

interface Props {
  className?: string;
  size?: string;
  tooltip?: string;
}

export const GreenLightningIcon = ({ size = "24", className, tooltip }: Props): JSX.Element => {
  return (
    <div className={styles.iconWrapper} data-testid="green-lightning-icon">
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        className={`${className || ''} ${styles.icon}`}
      >
        <circle cx="12" cy="12" r="12" fill="#50C878"/>
        <polygon 
          points="13,4 7,13 11,13 10,20 17,11 13,11" 
          fill="#fff"
        />
      </svg>
      {tooltip && (
        <div className={styles.tooltip}>
          {tooltip}
        </div>
      )}
    </div>
  );
};